import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
export const CollapseListSectionItem = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    dataHook,
    prefix,
    subtitle,
    suffix,
    showTooltip = true,
    tooltipText,
    disabled
  } = _ref;
  const renderTitle = useCallback(() => {
    if (typeof title === 'string') {
      return /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "normal"
      }, title);
    }
    return title;
  }, [title]);
  const renderTooltip = useCallback(() => {
    if (showTooltip) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        content: tooltipText,
        disabled: disabled
      }, /*#__PURE__*/React.createElement(Box, {
        color: disabled ? 'D40' : undefined,
        height: "18px",
        verticalAlign: "middle",
        width: "18px"
      }, /*#__PURE__*/React.createElement(InfoCircleSmall, null)));
    }
    return null;
  }, [disabled, showTooltip, tooltipText]);
  const renderHeader = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      align: "space-between",
      backgroundColor: "D70",
      dataHook: dataHook,
      direction: "horizontal",
      padding: "8px 16px",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1",
      verticalAlign: "middle"
    }, prefix, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1"
    }, renderTitle(), renderTooltip()), subtitle)), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP2",
      verticalAlign: "middle"
    }, suffix));
  }, [dataHook, prefix, renderTitle, renderTooltip, subtitle, suffix]);
  return renderHeader();
});
//# sourceMappingURL=collapse-list-section-item.js.map